var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuitcaseWithClockIcon = function SvgSuitcaseWithClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#suitcase-with-clock-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    fillRule: "evenodd",
    d: "M25.111 5v3.89h-8.889V5c0-.306.25-.555.556-.555h7.778c.306 0 .555.249.555.555M12.89 5v3.89H9A6.116 6.116 0 0 0 2.889 15v14.445A6.116 6.116 0 0 0 9 35.555h10.849A12.2 12.2 0 0 1 19 31.112c0-6.74 5.482-12.222 12.222-12.222 2.702 0 5.196.893 7.222 2.385V15a6.116 6.116 0 0 0-6.11-6.11h-3.89V5a3.893 3.893 0 0 0-3.889-3.889h-7.777a3.893 3.893 0 0 0-3.89 3.89m9.444 26.111c0-4.902 3.987-8.889 8.89-8.889 4.901 0 8.888 3.987 8.888 8.89 0 4.902-3.987 8.888-8.889 8.888s-8.889-3.986-8.889-8.889m12.487 3.145c.655 0 1.276-.39 1.54-1.034a1.665 1.665 0 0 0-.907-2.175l-2.564-1.053v-2.772a1.667 1.667 0 0 0-3.334 0v3.89a1.67 1.67 0 0 0 1.034 1.542l3.598 1.477q.314.126.633.125",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "suitcase-with-clock-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 0h40v40h-40z"
  })))));
};
export default SvgSuitcaseWithClockIcon;